import type { MetricsTranslations } from "../interfaces/metrics";

export const metricsTranslations: MetricsTranslations = {
  page_title: "Métricas",
  page_description:
    "O dinheiro que as carteiras, o OTC e os cartões movimentam, como os clientes começam e operam, o uso da plataforma e os experimentos, em todas as organizações.",
  tab_otc: "OTC",
  tab_experiments: "Experimentos",
  refresh: "Atualizar",
  period_label: "Período",
  period_option: "{{days}} dias",
  window_caption: "De {{from}} a {{to}}, comparado com os {{days}} dias anteriores.",
  error_title: "Não conseguimos carregar as métricas",
  error_text: "Tente novamente em instantes.",
  error_retry: "Tentar novamente",
  kpi_volume: "Volume",
  kpi_ticket: "Ticket médio",
  change_vs_previous: "{{change}} vs {{days}} dias anteriores",
  change_none: "Sem dados do período anterior",
  top_hint: "Por volume no período.",
  col_user: "Usuário",
  col_organization: "Organização",
  col_transactions: "Transações",
  col_volume: "Volume",
  col_ticket: "Ticket médio",
  via_api: "Via API",
  top_empty: "Ninguém operou neste período.",
  experiments_description: "Testes A/B: cada usuário sempre vê a mesma versão enquanto o teste roda.",
  experiments_empty: "Ainda não há experimentos.",
  col_experiment: "Experimento",
  col_status: "Status",
  col_split: "Divisão",
  col_users: "Usuários",
  col_started: "Início",
  status_RUNNING: "Em andamento",
  status_PAUSED: "Pausado",
  status_ROLLED_OUT: "Ligado para todos",
  experiment_otc_volume_discount: "Banner de desconto por volume (compra e venda de USDT)",
  variant_otc_volume_discount_control: "Sem banner",
  variant_otc_volume_discount_treatment: "Com banner",
  variant_users: "{{variant}}: {{users}}",
  detail_back: "Experimentos",
  detail_since: "Desde {{date}}",
  detail_until: "Até {{date}}",
  detail_not_found: "Não encontramos esse experimento.",
  detail_no_metric: "Este experimento ainda não tem métricas.",
  detail_how_to_read:
    "A conversão é a parcela de usuários que comprou ao menos uma vez desde que entrou no teste. Com menos de 30 usuários por grupo, leia a diferença como tendência.",
  group_users: "Usuários",
  group_conversion_rate: "Conversão",
  group_average: "Valor médio",
  significance_significant: "Diferença significativa",
  significance_trend: "Ainda não é conclusivo",
  significance_not_enough: "Faltam dados",
  action_pause: "Pausar",
  action_resume: "Retomar",
  action_rollout: "Ligar para todos",
  confirm_pause_title: "Pausar o experimento?",
  confirm_pause_text: "Todos verão a versão de controle. As atribuições são mantidas e a análise para aqui.",
  confirm_resume_title: "Retomar o experimento?",
  confirm_resume_text: "Cada usuário volta ao seu grupo e os novos são atribuídos ao acaso.",
  confirm_rollout_title: "Ligar para todos?",
  confirm_rollout_text:
    "Todos verão a versão “{{variant}}”, inclusive quem estava no outro grupo. A análise se encerra aqui.",
  confirm_cancel: "Cancelar",
  toast_updated: "Experimento atualizado",
  toast_failed: "Não conseguimos atualizar o experimento",
  action_split: "Alterar divisão",
  detail_split: "Divisão: {{split}}",
  split_title: "Alterar divisão",
  split_description: "A parcela dos novos usuários que vê cada versão.",
  split_presets_label: "Novos usuários em “{{variant}}”",
  split_input_label: "{{variant}} (%)",
  split_invalid_number: "Digite um número inteiro de 0 a 100.",
  split_total: "Total: {{total}} %",
  split_total_error: "Soma {{total}} %; precisa somar 100 %.",
  split_keep_note:
    "Quem já tem uma versão continua com ela. A nova divisão vale para quem chegar a partir de agora.",
  split_save: "Salvar divisão",
  toast_split_updated: "Divisão atualizada",
  toast_split_failed: "Não conseguimos alterar a divisão",
  user_section_title: "Versão por usuário",
  user_section_hint:
    "Busque alguém por nome ou e-mail para ver qual versão tem, mesmo antes de cotar, e mudá-la. Uma versão fixa aparece sempre, mesmo com o experimento pausado, e não conta nos resultados.",
  user_not_found: "Não encontramos um usuário com esse e-mail.",
  user_lookup_failed: "Não conseguimos consultar esse usuário.",
  user_sees: "Vê: {{variant}}",
  source_forced: "Versão fixada pela equipe.",
  source_assigned: "Sorteada em {{date}}.",
  source_not_assigned: "Ainda não cotou: esta é a versão que vai receber.",
  source_staff: "É da equipe: vê a versão em teste.",
  source_paused: "O experimento está pausado: vê a versão de controle.",
  source_rolled_out: "O experimento está ligado para todos.",
  user_force: "Fixar em “{{variant}}”",
  force_otc_volume_discount_treatment: "Ativar banner",
  force_otc_volume_discount_control: "Remover banner",
  user_release: "Voltar ao sorteio",
  user_release_hint: "Voltando ao sorteio, verá “{{variant}}”.",
  toast_forced: "{{email}} agora vê “{{variant}}”",
  toast_released: "{{email}} voltou ao sorteio",
  toast_override_failed: "Não conseguimos mudar a versão",
  overrides_title: "Usuários com versão fixa",
  overrides_since: "Desde {{date}}",
  group_average_otc_trade: "Ticket médio",
  overview_volume: "Volume total",
  overview_operations: "Operações",
  overview_users: "Usuários ativos",
  daily_title_volume: "Volume por dia",
  daily_title_operations: "Operações por dia",
  daily_hint: "Cada dia, as compras (de USDT e recargas de cartão, empilhadas) ao lado das vendas.",
  daily_measure_label: "Medida",
  side_buy_short: "Compras",
  side_sell_short: "Vendas",
  side_card_top_up_short: "Cartões",
  measure_volume: "Volume",
  measure_operations: "Operações",
  sides_title: "Compras, cartões e vendas",
  sides_hint: "Cada lado frente aos seus {{days}} dias anteriores.",
  col_metric: "Métrica",
  top_title: "Quem mais opera",
  top_tab_buy: "Compram mais",
  top_tab_sell: "Vendem mais",
  top_tab_card_top_up: "Recarregam cartões",
  verdict_title: "Resultado até hoje",
  verdict_headline_up: "“{{variant}}” converte {{change}} mais que “{{against}}”",
  verdict_headline_down: "“{{variant}}” converte {{change}} menos que “{{against}}”",
  verdict_headline_equal: "“{{variant}}” e “{{against}}” convertem igual",
  verdict_rates:
    "Operaram {{variantRate}} dos usuários “{{variant}}”, frente a {{againstRate}} de “{{against}}”.",
  verdict_significant: "A diferença é significativa (p = {{p}}): dificilmente é acaso.",
  verdict_trend: "Ainda pode ser acaso (p = {{p}}). Deixe o teste rodar.",
  verdict_not_enough:
    "Faltam dados: cada grupo precisa de ao menos 30 usuários. Leia a diferença como tendência.",
  verdict_empty: "Ainda ninguém operou no teste.",
  col_difference: "Diferença",
  currency_label: "Moeda",
  currency_info_label: "O que é USD aqui",
  currency_info:
    "Em USD você vê os USDT comprados e vendidos (1 USDT ≈ 1 USD). O preço por USD é sempre em pesos.",
  info_label: "O que inclui: {{metric}}",
  sides_split: "Compras {{buy}} · Cartões {{cards}} · Vendas {{sell}}",
  info_volume:
    "Compras, recargas de cartão e vendas concluídas no período. Uma compra ou uma recarga de cartão soma os pesos que o cliente pagou, com comissão; uma venda, os pesos que pagamos à chave dele, antes da nossa comissão. Em USD, os USDT entregues e recebidos.",
  overview_net_flow: "Fluxo líquido",
  info_net_flow:
    "Compras e recargas de cartão menos vendas, na moeda escolhida. Positivo: os clientes levaram mais USDT do que trouxeram. Negativo: trouxeram mais do que levaram.",
  net_flow_buy: "Compraram mais do que venderam",
  net_flow_sell: "Venderam mais do que compraram",
  net_flow_even: "Compraram o mesmo que venderam",
  info_operations:
    "Compras pagas (USDT entregues), recargas de cartão entregues (USDT enviados ao cartão) e vendas concluídas (pesos creditados) no período. As que falharam ou venceram não contam aqui: estão em «Não concluídas».",
  overview_users_new: "Novos: {{users}}",
  info_users:
    "Quem concluiu ao menos uma compra, recarga de cartão ou venda no período; uma operação via API conta como a sua organização. Novo: a primeira operação de sempre caiu neste período.",
  daily_difference: "Compras − vendas: {{value}}",
  daily_purchases_total: "Compras",
  daily_segment_usdt: "Compra de USDT",
  daily_segment_cards: "Recarga de cartão",
  daily_cards_share: "Recargas de cartão: {{share}} das compras do período.",
  side_label: "Lado",
  prices_title: "Preço por USD",
  prices_hint: "O que o cliente pagou ou recebeu por USDT, com comissões, ponderado pelo volume.",
  prices_buy: "Compraram a",
  prices_sell: "Venderam a",
  prices_card_top_up: "Recarregaram cartões a",
  prices_spread: "Diferença",
  prices_spread_meta: "{{percent}} sobre o preço de venda",
  info_spread:
    "Preço de compra menos preço de venda: o que separa quem compra de quem vende, com nossas comissões e a margem de liquidez incluídas.",
  prices_empty: "Sem compras nem vendas neste período: não há preço para mostrar.",
  info_price:
    "Pesos por USDT, com comissões, ponderado pelo volume. Compra: pesos debitados ÷ USDT recebidos. Recarga de cartão: pesos debitados ÷ USDT enviados ao cartão, antes da comissão de depósito do cartão. Venda: pesos creditados ÷ USDT vendidos.",
  info_volume_side:
    "Compra e recarga de cartão: os pesos que o cliente pagou, com comissão (em USD, os USDT entregues). Venda: os pesos que pagamos à chave dele, antes da nossa comissão (em USD, os USDT recebidos).",
  info_ticket: "Volume dividido pelas operações, na moeda escolhida.",
  row_duration: "Tempo real",
  duration_p90: "9 de cada 10 em menos de {{time}}",
  info_duration:
    "Mediana do período. Compra: da criação até a entrega dos USDT. Recarga de cartão: da criação até os USDT chegarem ao endereço do cartão, sem o tempo que o cartão leva para creditá-los. Venda: da chegada do depósito até pagarmos os pesos; pode somar até um minuto pela frequência com que a verificamos.",
  row_estimate: "Tempo que o cliente vê",
  estimate_network: "{{network}}: {{time}}",
  estimate_none: "Sem estimativa",
  info_estimate:
    "O que a tela de compra ou venda mostra hoje ao cliente, por rede. Vem das operações recentes, não deste período. As recargas de cartão mostram a sua própria espera, no cartão.",
  row_not_completed: "Não concluídas",
  not_completed_rate: "{{rate}} das que terminaram",
  info_not_completed:
    "Compras e recargas de cartão que falharam, foram canceladas ou revertidas, e vendas vencidas sem depósito ou devolvidas, que terminaram no período. A porcentagem é sobre todas as que terminaram, concluídas ou não.",
  reason_count: "{{reason}}: {{total}}",
  reason_failed: "Falhou",
  reason_cancelled: "Cancelada",
  reason_reversed: "Revertida",
  reason_expired: "Vencida sem depósito",
  reason_refunding: "Devolvendo",
  reason_refunded: "Devolvida",
  users_split: "Novos: {{new}} · Recorrentes: {{returning}}",
  info_users_side:
    "Quem concluiu ao menos uma operação desse lado; via API, conta a organização. Novo: a primeira operação desse lado caiu neste período.",
  conversion_split: "{{converted}} de {{quoted}} que cotaram",
  info_conversion:
    "Por usuário, não por cotação: quem cotou dez vezes e comprou uma vez converteu. Contam os usuários das organizações; a equipe não, porque as cotações dela costumam ser testes. As recargas de cartão não são cotadas na mesa, então não têm conversão.",
  intent_title: "Quem cotou e o que operou",
  intent_hint: "A maior cotação de cada usuário frente ao que acabou operando no período.",
  intent_quoted: "Cotaram",
  intent_converted: "Operaram",
  intent_captured: "Capturado",
  intent_captured_meta: "{{traded}} de {{quoted}} cotados",
  info_captured:
    "O que operaram os que cotaram, frente à soma da maior cotação de cada um. Passa de 100 % quando operaram mais do que cotaram.",
  intent_list_hint: "Os 10 com a maior cotação.",
  col_quotes: "Cotações",
  col_max_quote: "Maior cotação",
  col_traded: "Operado",
  quoter_traded: "Operou",
  quoter_not_traded: "Não operou",
  quoter_last: "Última cotação: {{date}}",
  intent_empty: "Ninguém cotou neste período.",
  user_search_label: "Usuário",
  user_search_placeholder: "Nome ou e-mail",
  user_search_hint: "Digite pelo menos 3 letras.",
  user_search_searching: "Buscando…",
  user_search_empty: "Ninguém corresponde a essa busca.",
  user_search_failed: "Não conseguimos buscar. Tente novamente.",
  user_would_see: "Receberia: {{variant}}",
  summary_title: "Resumo por versão",
  col_variant: "Versão",
  summary_baseline: "Referência",
  tab_tpv: "TPV",
  reason_rejected: "Rejeitada",
  tpv_overview_tpv: "TPV",
  tpv_info_tpv:
    "Cobranças confirmadas mais pagamentos pagos, em dólares à taxa do dia de cada operação. Swaps e recargas da Coloca não somam.",
  tpv_split: "Entra {{in}} · sai {{out}}",
  tpv_overview_revenue: "Receita da Coloca",
  tpv_info_revenue:
    "A comissão da Coloca em cobranças e pagamentos, a taxa de conversão (pagamentos entre moedas e swaps) e o resultado de execução da mesa nas compras de USDT, ainda não validado pelo financeiro. Não desconta custos de provedor nem impostos que a Coloca assume.",
  tpv_take_rate_value: "Take rate {{rate}}",
  tpv_ticket_value: "Ticket médio {{ticket}}",
  tpv_overview_organizations: "Organizações ativas",
  tpv_info_organizations:
    "Organizações com ao menos uma cobrança ou um pagamento no período. Novas: sua primeira operação da história cai no período.",
  tpv_organizations_new: "{{organizations}} novas",
  tpv_flow_title: "Por onde o dinheiro entra e sai",
  tpv_flow_hint: "O TPV do período por produto: à esquerda o que entra nas carteiras, à direita o que sai.",
  tpv_flow_in: "Entra",
  tpv_flow_out: "Sai",
  tpv_flow_net_in: "Entrou {{amount}} a mais do que saiu",
  tpv_flow_net_out: "Saiu {{amount}} a mais do que entrou",
  tpv_flow_net_even: "Entrou o mesmo que saiu",
  tpv_flow_empty: "Não houve cobranças nem pagamentos neste período.",
  tpv_flow_aria: "Entraram {{in}} e saíram {{out}}",
  tpv_flow_share: "{{share}} do que se moveu",
  tpv_product_collection: "Cobranças",
  tpv_product_otc_sell: "Venda de USDT",
  tpv_product_payout: "Pagamentos",
  tpv_product_otc_buy: "Compra de USDT",
  tpv_product_card_top_up: "Recarga de cartões",
  tpv_daily_title_volume: "TPV por dia",
  tpv_daily_title_operations: "Operações por dia",
  tpv_daily_hint: "Cobranças e pagamentos de cada dia, em dólares à taxa daquele dia.",
  tpv_series_in: "Cobranças",
  tpv_series_out: "Pagamentos",
  tpv_daily_net: "Líquido: {{value}}",
  tpv_flows_title: "Fluxos",
  tpv_flows_hint:
    "Cobranças e pagamentos formam o TPV; swaps e recargas da Coloca ficam à parte. Cada número frente aos {{days}} dias anteriores.",
  tpv_flow_payins: "Cobranças",
  tpv_flow_payouts: "Pagamentos",
  tpv_flow_fx: "Swaps",
  tpv_flow_top_ups: "Recargas Coloca",
  tpv_row_operations: "Operações",
  tpv_info_operations:
    "Cobranças confirmadas, pagamentos pagos, swaps e recargas, pela data em que se completaram.",
  tpv_row_volume: "Volume",
  tpv_info_volume:
    "Em dólares à taxa do dia de cada operação: o que o pagador enviou numa cobrança, o que saiu da carteira num pagamento ou swap, taxa de conversão incluída.",
  tpv_row_ticket: "Ticket médio",
  tpv_info_ticket: "Volume dividido pelas operações convertidas em dólares.",
  tpv_row_revenue: "Receita",
  tpv_revenue_service: "Comissão {{amount}}",
  tpv_revenue_conversion: "Conversão {{amount}}",
  tpv_revenue_fx_execution: "Execução OTC {{amount}}",
  tpv_row_take_rate: "Take rate",
  tpv_info_take_rate: "Receita sobre volume. No total, toda a receita (inclusive a de swaps) sobre o TPV.",
  tpv_row_organizations: "Organizações",
  tpv_row_not_completed: "Não concluídas",
  tpv_info_not_completed:
    "Cobranças rejeitadas, falhas ou revertidas e pagamentos falhos, cancelados ou revertidos, por quando terminaram. Cobranças que ninguém pagou e venceram ficam à parte.",
  tpv_row_expired: "Cobranças vencidas",
  tpv_info_expired:
    "QR ou CLABE que ninguém pagou e que o sistema fechou ao vencer. Não é uma falha: é uma cobrança que não foi usada.",
  tpv_row_in_flight: "Em andamento agora",
  tpv_info_in_flight:
    "Cobranças detectadas sem confirmar e pagamentos criados ou no provedor, neste momento e à taxa de hoje.",
  tpv_in_flight_value: "{{operations}} · {{amount}}",
  tpv_unconverted: "{{operations}} sem taxa, fora dos dólares",
  tpv_corridors_title: "Produtos e corredores",
  tpv_corridors_hint: "Cada cobrança e pagamento por produto, rail, país e moeda, do maior ao menor volume.",
  tpv_col_product: "Produto",
  tpv_col_rail: "Rail",
  tpv_col_country: "País",
  tpv_col_currency: "Moeda",
  tpv_col_operations: "Operações",
  tpv_col_volume: "Volume",
  tpv_col_revenue: "Receita",
  tpv_col_share: "Participação",
  tpv_col_change: "Variação",
  tpv_direction_in: "Entra",
  tpv_direction_out: "Sai",
  tpv_corridors_empty: "Não houve cobranças nem pagamentos neste período.",
  tpv_fx_pairs_title: "Swaps por par",
  tpv_col_pair: "Par",
  tpv_custody_title: "Saldos em custódia",
  tpv_custody_hint:
    "O que as carteiras de pagamento têm hoje, avaliado pela última taxa conhecida. A variação líquida vem do livro contábil.",
  tpv_custody_available: "Disponível",
  tpv_info_custody_available: "Saldo que as organizações já podem usar.",
  tpv_custody_pending: "Pendente",
  tpv_info_custody_pending: "Cobranças detectadas que ainda não foram confirmadas.",
  tpv_custody_blocked: "Bloqueado",
  tpv_info_custody_blocked: "Reservado por pagamentos ainda em andamento; já saiu do saldo disponível.",
  tpv_custody_wallets: "Carteiras",
  tpv_info_custody_wallets:
    "Carteiras de pagamento de todas as organizações. Ativas: organização e moeda com uma cobrança, pagamento ou swap no período.",
  tpv_custody_wallets_meta: "{{active}} ativas · {{new}} novas",
  tpv_col_net_change: "Variação líquida",
  tpv_info_net_change:
    "Créditos menos débitos das carteiras nessa moeda durante o período, segundo o livro contábil. Inclui estornos e ajustes, então não bate com o saldo de hoje.",
  tpv_custody_wallet_count: "{{wallets}} carteiras",
  tpv_custody_no_rate: "Sem taxa",
  tpv_custody_empty: "Não há carteiras de pagamento.",
  tpv_col_tpv: "TPV",
  tpv_col_payins: "Cobranças",
  tpv_col_payouts: "Pagamentos",
  tpv_unnamed_organization: "Sem nome",
  tpv_rates_title: "Taxas para dólares",
  tpv_rates_info:
    "Cada valor é convertido pela taxa em dólares do seu próprio dia, do histórico de taxas. USD e USDT valem 1. Um dia sem taxa própria usa a do dia conhecido mais próximo.",
  tpv_rates_filled: "{{share}} dos dias com operações usou a taxa do dia mais próximo.",
  tpv_rates_exact: "Todos os dias com operações têm a própria taxa.",
  tpv_rates_missing: "Sem taxa, fora dos dólares: {{currencies}}.",
  tpv_rates_latest: "Última taxa: {{date}}.",
  tpv_filter_label: "Organização",
  tpv_filter_all: "Todas as organizações",
  tpv_filter_all_hint: "Cada número soma todas as organizações.",
  tpv_filter_org_hint: "Cada número é só desta organização: fluxos, corredores, saldos e a série diária.",
  tpv_organizations_title: "Organizações",
  tpv_organizations_hint:
    "Todas que tiveram uma cobrança, um pagamento ou um swap neste período ou no anterior. As que pararam de operar ficam no fim.",
  tpv_organizations_search: "Buscar por nome ou id",
  tpv_organizations_sort_label: "Ordenar por",
  tpv_sort_tpv: "TPV",
  tpv_sort_operations: "Operações",
  tpv_sort_revenue: "Receita",
  tpv_organizations_show_all: "Ver todas ({{organizations}})",
  tpv_organizations_show_less: "Ver só as 10 primeiras",
  tpv_organizations_empty: "Nenhuma organização operou neste período.",
  tpv_organizations_no_match: "Nenhuma organização corresponde a “{{term}}”.",
  tpv_col_transactions: "Transações",
  tpv_previous_value: "Antes {{amount}}",
  tpv_action_only_this: "Ver só esta",
  tpv_action_only_this_aria: "Ver a página só para {{organization}}",
  tpv_action_payins: "Cobranças ({{operations}})",
  tpv_action_payouts: "Pagamentos ({{operations}})",
  tpv_action_view_transactions: "Ver transações",
  tpv_corridors_link_note:
    "“Ver transações” filtra por rail: em Bre-B também aparecem as vendas de USDT, e em USDT as compras e as recargas de cartão vêm juntas.",
  tab_home: "Resumo",
  tab_cards: "Cartões",
  tab_users: "Usuários",
  home_view_detail: "Ver detalhe",
  home_section_error: "Não conseguimos carregar esta seção.",
  home_tpv_volume: "TPV",
  home_tpv_revenue: "Receita da Coloca",
  home_tpv_organizations: "Organizações ativas",
  home_otc_volume: "Volume",
  home_otc_operations: "Operações",
  home_otc_users: "Usuários ativos",
  home_cards_spend: "Gasto",
  home_cards_active: "Cartões ativos",
  home_cards_approval: "Aprovação",
  home_users_registered: "Cadastros",
  home_users_approved: "KYC aprovados",
  home_users_first: "Primeira transação",
  home_attention_title: "Para revisar",
  home_attention_hint: "O que saiu do normal no período, com o link para onde se resolve.",
  home_attention_empty: "Nada fora do normal no período.",
  home_attention_loading: "Verificando as seções…",
  attention_verified_without_transaction:
    "{{total}} clientes com KYC aprovado e nenhuma transação há mais de {{days}} dias",
  attention_kyc_in_review_stale: "{{total}} verificações KYC em revisão há mais de {{days}} dias",
  attention_card_approval_drop: "A aprovação de cartões caiu {{points}}",
  attention_card_approval_reason: "{{reason}} explica {{share}} das recusas",
  attention_card_spend_drop: "O gasto com cartões mudou {{change}} frente ao período anterior",
  attention_tpv_up: "O TPV cresceu {{change}}",
  attention_tpv_down: "O TPV caiu {{change}}",
  attention_tpv_driver: "{{organization}} explica {{share}} da mudança",
  cards_tile_spend: "Gasto",
  cards_tile_approval: "Aprovação",
  cards_tile_active_cards: "Cartões ativos",
  cards_tile_cardholders: "Portadores ativos",
  cards_tile_loads: "Carregado",
  cards_tile_holdings: "Saldo nos cartões",
  info_cards_spend:
    "Compras e saques em caixa aprovados, em dólares. Uma compra liquidada conta uma vez só, e devolver saldo à carteira de cartões não é gasto.",
  info_cards_approval:
    "Compras aprovadas sobre o total de tentativas (aprovadas mais recusadas). A mudança vai em pontos percentuais.",
  info_cards_active_cards:
    "Cartões com pelo menos uma compra aprovada no período. Ao lado, os cartões criados no período.",
  info_cards_cardholders:
    "Pessoas com pelo menos uma compra aprovada. Novos: a primeira compra na Coloca foi neste período.",
  info_cards_loads:
    "O que entrou nos cartões: pela carteira de cartões, por depósito cripto ou a partir de pesos (chega pela Polygon).",
  info_cards_holdings:
    "O que todos os cartões têm hoje, segundo a última leitura do provedor: o que a Coloca garante.",
  cards_spend_meta: "{{purchases}} compras · ticket {{ticket}}",
  cards_declined_meta: "{{total}} recusadas",
  cards_active_cards_meta: "com pelo menos uma compra · {{issued}} criados",
  cards_cardholders_meta: "{{total}} novos neste período",
  cards_loads_meta: "saldo {{wallet}} · cripto {{crypto}} · pesos {{pesos}}",
  cards_holdings_meta: "em {{total}} cartões com saldo",
  cards_daily_title_amount: "Gasto por dia",
  cards_daily_title_count: "Compras por dia",
  cards_daily_hint: "Compras aprovadas e recusadas de cada dia.",
  cards_measure_amount: "Valor",
  cards_measure_count: "Compras",
  cards_series_approved: "Aprovadas",
  cards_series_declined: "Recusadas",
  cards_daily_footer: "Aprovação {{rate}}",
  cards_merchants_title: "Comércios onde mais se gasta",
  cards_merchants_hint: "Os 10 primeiros do período; um mesmo comércio com dois nomes conta duas vezes.",
  cards_merchants_empty: "Sem compras no período",
  cards_merchant_card_meta: "{{purchases}} compras · {{cardholders}} portadores",
  cards_col_merchant: "Comércio",
  cards_col_category: "Categoria",
  cards_col_spend: "Gasto",
  cards_col_purchases: "Compras",
  cards_col_share: "Do gasto",
  cards_col_cardholders: "Portadores",
  cards_categories_title: "Por categoria",
  cards_categories_hint: "Gasto por tipo de comércio.",
  cards_category_other: "Outros",
  cards_cardholders_title: "Quem mais gasta",
  cards_cardholders_hint: "Portadores por gasto no período.",
  cards_cardholders_empty: "Ninguém comprou no período",
  cards_cardholders_show_all: "Ver os {{count}}",
  cards_cardholders_show_less: "Ver menos",
  cards_cardholder_card_meta:
    "{{purchases}} compras · ticket {{ticket}} · {{declined}} recusadas · última {{last}}",
  cards_col_cardholder: "Portador",
  cards_col_organization: "Organização",
  cards_col_cards: "Cartões",
  cards_col_ticket: "Ticket",
  cards_col_declined: "Recusadas",
  cards_col_last_purchase: "Última compra",
  cards_organizations_title: "Organizações por gasto em cartões",
  cards_organizations_hint: "Onde está o volume de cartões e como se move.",
  cards_organizations_empty: "Nenhuma organização usou cartões no período",
  cards_organization_card_meta: "{{cards}} cartões ativos · aprovação {{approval}}",
  cards_col_active_cards: "Cartões ativos",
  cards_col_change: "Mudança",
  cards_col_approval: "Aprovação",
  cards_declines_title: "Por que são recusadas",
  cards_declines_hint: "{{total}} compras recusadas no período, por motivo.",
  cards_declines_empty: "Nenhuma compra recusada no período.",
  decline_INSUFFICIENT_CARD_BALANCE: "Saldo insuficiente no cartão",
  decline_INSUFFICIENT_PROVIDER_FUNDS: "Fundos insuficientes do emissor",
  decline_CARD_NOT_ACTIVE: "Cartão não ativo",
  decline_LIMIT_EXCEEDED: "Limite excedido",
  decline_MERCHANT_BLOCKED: "Comércio não permitido",
  decline_INVALID_CARD_DATA: "Dados do cartão incorretos",
  decline_SUSPECTED_FRAUD: "Suspeita de fraude",
  decline_PROVIDER_ERROR: "Erro do processador",
  decline_UNKNOWN: "Outro motivo",
  users_cohort_note:
    "Aqui um usuário é um cliente (organização): o KYC/KYB é o da organização e a primeira transação, a primeira operação dessa organização. A organização da Coloca fica de fora.",
  users_tile_registered: "Cadastros",
  users_tile_kyc_started: "KYC iniciado",
  users_tile_kyc_approved: "KYC aprovado",
  users_tile_first_transaction: "Primeira transação",
  users_tile_active: "Clientes ativos",
  info_users_registered:
    "Organizações criadas no período. Cada etapa desta página acompanha esses mesmos clientes até hoje.",
  info_users_kyc_started: "Dos cadastrados, os que iniciaram a verificação da organização (KYC ou KYB).",
  info_users_kyc_approved: "Dos cadastrados, os que têm a verificação aprovada hoje.",
  info_users_first_transaction:
    "Dos cadastrados, os que já operaram: uma cobrança, um envio, uma compra com cartão ou uma compra ou venda de USDT.",
  info_users_active: "Clientes de qualquer idade que fizeram alguma operação no período.",
  users_registered_meta: "clientes novos no período",
  users_share_meta: "{{rate}} dos cadastros",
  users_approved_meta: "{{rate}} dos cadastros · {{rejected}} recusados",
  users_active_meta: "com alguma operação no período",
  users_step_registered: "Cadastro",
  users_step_email_verified: "E-mail verificado",
  users_step_kyc_started: "KYC iniciado",
  users_step_kyc_in_review: "KYC em revisão",
  users_step_kyc_rejected: "KYC recusado",
  users_step_kyc_approved: "KYC aprovado",
  users_step_first_transaction: "Primeira transação",
  users_funnel_title: "Do cadastro à primeira transação",
  users_funnel_hint: "Clientes cadastrados no período e até onde chegaram.",
  users_funnel_empty: "Ninguém se cadastrou no período.",
  users_funnel_of_previous: "{{rate}} da anterior",
  users_funnel_chart_title: "Funil de clientes",
  users_funnel_chart_hint:
    "A mesma coorte vista como funil: a largura é a parte dos cadastros que chega a cada etapa e, ao lado, quantos ficam entre uma etapa e a seguinte.",
  users_drops_title: "Onde ficam",
  users_drop_row: "{{from}} → {{to}}",
  users_worst_drop: "A etapa com mais perda é de {{from}} a {{to}}: {{lost}} de {{total}} clientes.",
  users_durations_title: "Quanto demora",
  users_durations_hint: "Mediana e os 90 % mais lentos (p90) entre cada etapa.",
  users_col_step: "Etapa",
  users_col_median: "Mediana",
  users_col_p90: "p90",
  users_col_samples: "Clientes",
  span_minutes: "{{value}} min",
  span_hours: "{{value}} h",
  span_days: "{{value}} dias",
  users_first_title: "O que fazem primeiro",
  users_first_hint: "O produto da primeira transação de cada cliente novo.",
  users_first_empty: "Nenhum cliente novo operou ainda.",
  users_product_payin: "Cobrança",
  users_product_payout: "Envio",
  users_product_otc_buy: "Compra de USDT",
  users_product_otc_sell: "Venda de USDT",
  users_product_card: "Compra com cartão",
  users_recent_title: "Cadastros recentes",
  users_recent_hint:
    "Em que etapa está cada cliente novo e há quanto tempo. Os que estão há mais de {{days}} dias numa etapa ficam marcados.",
  users_recent_empty: "Ainda não há cadastros",
  users_recent_card_meta: "Cadastro {{registered}} · último acesso {{login}}",
  users_col_client: "Cliente",
  users_col_registered: "Cadastro",
  users_col_stage: "Etapa atual",
  users_col_in_stage: "Na etapa",
  users_col_last_login: "Último acesso",
  users_in_stage_days: "{{count}} dias",
  tab_platform: "Plataforma",
  monthly_in_progress: "em andamento",
  monthly_trend: "{{lastMonth}}: {{last}}. Contra {{firstMonth}}:",
  org_scope_note: "Somente {{name}}. As comparações entre organizações ficam ocultas.",
  org_scope_note_otc: "Somente {{name}}: números, gráficos e usuários dessa organização.",
  cards_monthly_title: "Gasto por mês",
  cards_monthly_hint: "Os últimos 12 meses de todas as organizações. O mês atual ainda está em andamento.",
  cards_monthly_hint_org: "Os últimos 12 meses de {{name}}. O mês atual ainda está em andamento.",
  cards_series_spend: "Gasto",
  cards_series_purchases: "Compras",
  cards_holders_title: "Quem tem mais saldo",
  cards_holders_hint:
    "As 15 organizações com mais saldo hoje: a carteira de cartões mais o que está carregado nos cartões.",
  cards_holders_wallet: "Carteira de cartões",
  cards_holders_cards: "Nos cartões",
  cards_holders_share: "{{share}} do total",
  cards_holders_empty: "Nenhuma organização tem saldo em cartões hoje.",
  cards_holders_row_label: "{{name}}: {{wallet}} na carteira de cartões e {{cards}} nos cartões",
  cards_holders_row_detail: "Carteira {{wallet}} · {{cards}} em {{cardCount}} cartões",
  info_cards_holders:
    "Saldo de hoje em USD: o da carteira de cartões da organização (e seus bolsos) mais o dos cartões que não compartilham saldo com uma carteira. A porcentagem é sobre o total de todas as organizações, sem a da Coloca.",
  cards_shares_title: "Quem gasta mais a cada mês",
  cards_shares_hint:
    "A parte do gasto de cada um dos últimos 6 meses feita por cada organização. A variação compara o último mês com o primeiro.",
  cards_shares_col_organization: "Organização",
  cards_shares_col_change: "Variação",
  cards_shares_others: "Outras ({{total}})",
  cards_shares_empty: "Ainda não há gasto com cartão nesses meses.",
  info_cards_shares:
    "Compras aprovadas em USD de cada mês calendário (horário da Colômbia), sem a organização da Coloca. Aparecem as 10 que mais gastaram nos 6 meses e o resto soma em «Outras». A variação é em pontos percentuais.",
  otc_monthly_title: "Volume por mês",
  otc_monthly_hint:
    "Os últimos 12 meses de todas as organizações, por lado. O mês atual ainda está em andamento.",
  otc_monthly_hint_org: "Os últimos 12 meses de {{name}}, por lado. O mês atual ainda está em andamento.",
  users_registrations_title: "Cadastros por dia",
  users_registrations_hint:
    "{{total}} organizações novas nos últimos {{days}} dias. A linha é o mesmo dia do período anterior.",
  users_registrations_current: "Este período",
  users_registrations_previous: "Período anterior",
  users_activity_title: "Clientes que operam",
  users_activity_hint:
    "Daqui em diante, todas as organizações que operam, não só as cadastradas no período. O volume é em USD: cobranças confirmadas, envios pagos e gasto com cartão.",
  users_movers_title: "Quem está saindo e quem está crescendo",
  users_movers_hint: "Volume dos últimos {{days}} dias contra os {{days}} anteriores.",
  info_users_movers:
    "Cobranças confirmadas, envios pagos e gasto com cartão, em USD pela taxa de cada dia. «Saindo»: movimentavam algo no período anterior e caíram {{threshold}} ou mais, ou a zero. «Crescendo»: subiram pelo menos {{floor}}. Sem a organização da Coloca.",
  users_movers_tab_falling: "Saindo ({{total}})",
  users_movers_tab_growing: "Crescendo ({{total}})",
  users_movers_empty_falling: "Nenhum cliente caiu {{threshold}} ou mais neste período.",
  users_movers_empty_growing: "Nenhum cliente subiu {{floor}} ou mais neste período.",
  users_movers_more: "{{shown}} de {{total}} listados.",
  users_list_show_all: "Ver todos ({{total}})",
  users_list_show_less: "Ver menos",
  users_movers_before: "Antes",
  users_movers_now: "Agora",
  users_movers_new: "novo",
  users_movers_stopped: "parou de operar",
  users_movers_values: "{{before}} → {{now}}",
  users_movers_ops: "{{current}} operações (antes {{previous}})",
  users_movers_last: "última: {{date}}",
  users_inactive_title: "Dias sem operar",
  users_inactive_hint:
    "Clientes que operaram nos últimos {{lookback}} dias mas estão há {{days}} dias ou mais sem operar, os de maior volume primeiro.",
  users_inactive_empty: "Nenhum cliente está há {{days}} dias ou mais sem operar.",
  users_inactive_moved: "{{amount}} em {{operations}} operações em {{lookback}} dias",
  users_inactive_days: "{{total}} dias",
  users_products_title: "Produtos por cliente",
  users_products_hint:
    "O que usam as {{organizations}} organizações que operaram nos últimos {{lookback}} dias.",
  info_users_products:
    "Um produto está em uso se a organização o usou nos últimos {{lookback}} dias; «antes» se o usou alguma vez, mas não nesse tempo. Produtos: cobranças, envios, compra e venda de USDT, recargas de cartão com pesos e gasto com cartão.",
  users_products_usage: "{{recent}} em uso ({{share}}) · {{ever}} alguma vez",
  users_products_by_org: "Por organização, as de maior volume primeiro",
  users_products_legend_recent: "Em uso (últimos {{lookback}} dias)",
  users_products_legend_before: "Usou antes",
  users_products_legend_never: "Nunca usou",
  users_products_col_organization: "Organização",
  users_products_col_volume: "Volume {{lookback}} dias",
  users_products_empty: "Nenhuma organização operou nos últimos {{lookback}} dias.",
  activity_product_collection: "Cobranças",
  activity_product_payout: "Envios",
  activity_product_otc_buy: "Compra USDT",
  activity_product_otc_sell: "Venda USDT",
  activity_product_card_top_up: "Recarga com pesos",
  activity_product_card: "Cartões",
  home_platform_active: "Usuários ativos",
  home_platform_session: "Tempo por sessão",
  home_platform_top_section: "Seção mais usada",
  attention_clients_falling: "{{total}} clientes reduziram o volume em {{threshold}} ou mais",
  attention_clients_inactive: "{{total}} clientes estão há {{days}} dias ou mais sem operar",
  platform_audience_label: "De quem",
  platform_audience_clients: "Clientes",
  platform_audience_staff: "Staff",
  platform_tracking_none:
    "Ainda não há visitas registradas: o uso é contado desde que o registro foi ativado. Os logins trazem todo o histórico.",
  platform_tracking_partial:
    "As visitas são contadas desde {{date}}, então os números de uso antes desse dia ficam em zero. Os logins trazem todo o histórico.",
  platform_tile_active: "Usuários ativos",
  info_platform_active: "Pessoas que abriram pelo menos uma página do dashboard no período.",
  platform_active_meta: "De {{organizations}} organizações",
  platform_tile_daily: "Ativos por dia",
  info_platform_daily: "A média de pessoas com alguma visita em cada dia do período.",
  platform_daily_meta: "{{weekly}} nos últimos 7 dias",
  platform_tile_sessions: "Sessões",
  info_platform_sessions:
    "Períodos de uso de uma pessoa em um navegador. Uma sessão termina após 30 minutos sem usar o dashboard.",
  platform_sessions_meta: "{{perUser}} por pessoa",
  platform_tile_session_time: "Tempo por sessão",
  info_platform_session_time:
    "A mediana do tempo de uma sessão, contando só os minutos com a aba visível e alguém usando. Abaixo, a média.",
  platform_session_time_meta: "Média {{average}}",
  platform_tile_logins: "Logins",
  info_platform_logins: "Logins bem-sucedidos no dashboard ou no app no período.",
  platform_logins_meta: "De {{people}} pessoas",
  platform_daily_title: "Usuários ativos e logins por dia",
  platform_daily_hint: "Quantas pessoas usaram o dashboard a cada dia e quantas vezes alguém fez login.",
  platform_series_active: "Usuários ativos",
  platform_series_logins: "Logins",
  platform_daily_footer: "{{sessions}} sessões · {{time}} de uso",
  platform_sections_title: "Seções mais usadas",
  info_platform_sections:
    "Tempo de uso por seção do menu: a aba visível e alguém usando. A porcentagem é sobre todo o tempo de uso do período.",
  platform_sections_hint: "Para onde vai o tempo no dashboard.",
  platform_section_row: "{{people}} pessoas · {{visits}} visitas",
  platform_section_home: "Início",
  platform_section_operations: "Operações",
  platform_section_cards: "Cartões",
  platform_section_analytics: "Análise",
  platform_section_management: "Gestão",
  platform_section_account: "Conta e ajustes",
  platform_section_other: "Outras",
  platform_pages_title: "Páginas mais usadas",
  platform_pages_hint: "As 15 páginas com mais tempo de uso, como o menu as nomeia.",
  platform_pages_col_page: "Página",
  platform_pages_col_time: "Tempo",
  platform_pages_col_share: "Do total",
  platform_pages_col_visits: "Visitas",
  platform_pages_col_people: "Pessoas",
  platform_empty_visits: "Não há visitas registradas neste período.",
  platform_heat_title_usage: "Horários de mais uso",
  platform_heat_title_logins: "Horários com mais logins",
  info_platform_heatmap:
    "Dia da semana e hora da Colômbia. «Uso» soma o tempo das visitas que começaram nessa hora; «Logins» conta os logins, com todo o histórico.",
  platform_heat_hint: "Quando entram na plataforma, por dia e hora da Colômbia.",
  platform_heat_peak: "O pico é {{day}} às {{hour}} (horário da Colômbia): {{value}}.",
  platform_heat_metric_label: "O que o mapa mede",
  platform_heat_usage: "Uso",
  platform_heat_logins: "Logins",
  platform_heat_logins_value: "{{logins}} logins",
  platform_heat_low: "Menos",
  platform_heat_high: "Mais",
  platform_heat_idle: "Passe o cursor sobre uma célula para ver o valor.",
  platform_heat_empty_logins: "Não há logins neste período.",
  platform_devices_title: "De onde entram",
  info_platform_devices:
    "Cada login classificado pelo navegador ou app que o fez: computador, navegador do celular ou o app móvel.",
  platform_devices_hint: "{{total}} logins no período.",
  platform_device_desktop_web: "Web no computador",
  platform_device_mobile_web: "Web no celular",
  platform_device_app: "App móvel",
  platform_device_unknown: "Não identificado",
  platform_device_row: "{{share}} · {{sessions}} logins · {{people}} pessoas",
  platform_browsers_title: "Navegadores e sistemas",
  platform_browser_row: "{{sessions}} ({{share}})",
  org_filter_hint: "Os números, gráficos e listas são só desta organização.",
};
